module.exports = __webpack_public_path__ + "static/media/herbaltea.6d2eddfd.jpg";